import script from "./SignUpSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignUpSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./SignUpSuccess.vue?vue&type=style&index=0&id=feb09418&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb09418"]])

export default __exports__